      window.addEventListener('DOMContentLoaded', () => {
        const scrollContainer = document.querySelector('.product--columns media-gallery slider-component');
        let isDragging = false;
        let startX;
        let scrollLeft;
    
        scrollContainer?.addEventListener('mousedown', (e) => {
            if (e.button !== 0) return;
          
            isDragging = true;
            scrollContainer.classList.add('active');
            startX = e.pageX - scrollContainer.offsetLeft;
            scrollLeft = scrollContainer.scrollLeft;
        });
    
        scrollContainer?.addEventListener('mouseleave', () => {
            isDragging = false;
            scrollContainer.classList.remove('active');
        });
    
        scrollContainer?.addEventListener('mouseup', () => {
            isDragging = false;
            scrollContainer.classList.remove('active');
        });
    
        scrollContainer?.addEventListener('mousemove', (e) => {
            if (!isDragging) return;
            e.preventDefault();
            const x = e.pageX - scrollContainer.offsetLeft;
            const walk = (x - startX) * 2;
            scrollContainer.scrollLeft = scrollLeft - walk;
        });
    
        const scrollWrapper = document.querySelector('.product--columns media-gallery slider-component');
        const scrollBarThumb = document.querySelector('.scroll-bar-thumb');
    
        function updateScrollBar() {
            const scrollWidth = scrollWrapper.scrollWidth;
            const clientWidth = scrollWrapper.clientWidth;
            const thumbWidth = (clientWidth / scrollWidth) * clientWidth;
            scrollBarThumb.style.width = `${thumbWidth}px`;
        }
    
        function syncScrollBar() {
            const scrollLeft = scrollWrapper.scrollLeft;
            const scrollWidth = scrollWrapper.scrollWidth - scrollWrapper.clientWidth;
            const maxThumbLeft = scrollWrapper.clientWidth - scrollBarThumb.offsetWidth;
            const thumbLeft = (scrollLeft / scrollWidth) * maxThumbLeft;
            scrollBarThumb.style.transform = `translateX(${thumbLeft}px)`;
        }
    
        scrollWrapper.addEventListener('scroll', syncScrollBar);
        window.addEventListener('resize', updateScrollBar);
        updateScrollBar();
    
        if (window.innerWidth >= 990) {
            let startX2;
    
            scrollContainer.addEventListener("wheel", (event) => {
                const atEnd = scrollContainer.scrollLeft + scrollContainer.clientWidth >= scrollContainer.scrollWidth - 1;
    
                if (!atEnd) {
                    event.preventDefault();
                    scrollContainer.scrollLeft += event.deltaY;
                }
    
                if (event.deltaY < 0 && window.scrollY <= 0) {
                    event.preventDefault();
                    scrollContainer.scrollLeft += event.deltaY;
                } 
            });
    
            scrollContainer.addEventListener("touchstart", (e) => {
                startX2 = e.touches[0].pageX - scrollContainer.offsetLeft;
                scrollLeft = scrollContainer.scrollLeft;
            });
    
            scrollContainer.addEventListener("touchmove", (e) => {
                e.preventDefault();
                const x = e.touches[0].pageX - scrollContainer.offsetLeft;
                const walk = (x - startX2) * 2;
                scrollContainer.scrollLeft = scrollLeft - walk;
            });
        }
    
        document.addEventListener('keydown', (event) => {
            if (!scrollContainer) return;
    
            const scrollAmount = 300; 
    
            if (event.key === 'ArrowRight') {
              scrollContainer.scrollBy({ left: scrollAmount, behavior: "smooth" });
            } else if (event.key === 'ArrowLeft') {
                scrollContainer.scrollBy({ left: -scrollAmount, behavior: "smooth" });
            }
        });
    });
    

  // document.addEventListener("DOMContentLoaded", function () {
  //   const sliders = document.querySelectorAll('.product--columns media-gallery slider-component');

  //   sliders.forEach((slider) => {
  //     let isDown = false;
  //     let startX;
  //     let scrollLeft;

  //     slider.addEventListener('mousedown', (e) => {
  //       isDown = true;
  //       slider.classList.add('active');
  //       startX = e.pageX - slider.offsetLeft;
  //       scrollLeft = slider.scrollLeft;
  //     });

  //     slider.addEventListener('mouseleave', () => {
  //       isDown = false;
  //       slider.classList.remove('active');
  //     });

  //     slider.addEventListener('mouseup', () => {
  //       isDown = false;
  //       slider.classList.remove('active');
  //     });

  //     slider.addEventListener('mousemove', (e) => {
  //       if (!isDown) return;
  //       e.preventDefault();
  //       const x = e.pageX - slider.offsetLeft;
  //       const walk = (x - startX) * 1.5; // drag speed
  //       slider.scrollLeft = scrollLeft - walk;
  //     });
  //   });
  // });


// document.addEventListener("DOMContentLoaded", function () {
//     const slider = document.querySelector('.product--columns media-gallery slider-component');

//     if (slider) {
//       slider.addEventListener('wheel', function (e) {
//         // Only trigger for desktop (width > 990px)
//         if (window.innerWidth >= 990) {
//           e.preventDefault();
//           slider.scrollLeft += e.deltaY; // or e.deltaY * 1.5 for faster scroll
//         }
//       }, { passive: false });
//     }
//   });

document.addEventListener("DOMContentLoaded", function () {
    const slider = document.querySelector('.product--columns media-gallery slider-component');

    if (!slider) return;

    let atEnd = false;

    slider.addEventListener('wheel', function (e) {
      if (window.innerWidth < 990) return; // Only desktop

      const scrollAmount = e.deltaY;
      const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
      const currentScrollLeft = slider.scrollLeft;

      // If not at end, scroll horizontally
      if (currentScrollLeft < maxScrollLeft && scrollAmount > 0) {
        e.preventDefault();
        slider.scrollLeft += scrollAmount;
        atEnd = false;
      }
      // If scrolling up and not at start, scroll back
      else if (currentScrollLeft > 0 && scrollAmount < 0) {
        e.preventDefault();
        slider.scrollLeft += scrollAmount;
        atEnd = false;
      }
      // If already at end (right side), allow vertical scroll
      else if (currentScrollLeft >= maxScrollLeft && scrollAmount > 0 && !atEnd) {
        atEnd = true;
        // Smooth scroll page down after gallery ends
        window.scrollBy({
          top: 100,
          behavior: 'smooth'
        });
      }
    }, { passive: false });
  });
